const videoContainers = document.querySelectorAll(
    '.wp-block-listing .video-container'
);
const popouts = document.querySelectorAll('.popout');
const accordions = document.querySelectorAll('.accordion');
const wpBlocks = document.querySelectorAll('.wp-block');
const forms = document.querySelectorAll('.contact-form');

document.addEventListener('DOMContentLoaded', () => {
    if (popouts) {
        renderPopouts();
    }
});

let options = {
    root: null,
    rootMargin: '-100px',
    threshold: 0,
};

let callback = (entries, observer) => {
    entries.forEach((entry) => {
        const block = entry.target;
        const blockTop = block.getBoundingClientRect().top;

        if (entry.isIntersecting || blockTop < 0) {
            block.classList.add('is-in-viewport');
            observer.unobserve(block);
        }
    });
};

let observer = new IntersectionObserver(callback, options);

wpBlocks.forEach((block) => {
    observer.observe(block);
});

videoContainers.forEach((element) => {
    const controls = element.querySelector('.video-container__control button');
    const video = element.querySelector('video');

    controls.addEventListener('click', (e) => {
        let state = e.target.dataset.state;
        if (state === 'playing') {
            controls.dataset.state = 'paused';
            video?.pause();
        } else {
            controls.dataset.state = 'playing';
            video?.play();
        }
    });
});

accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion__item');

    items.forEach((el) => {
        // const toggle = el.querySelector('.accordion__toggle');

        el?.addEventListener('click', (e) => {
            toggleAccordionItem(el, accordion);
        });
    });
});

function toggleAccordionItem(item, accordion) {
    const state = item.dataset.state;
    //   const toggle = accordion.querySelector('.accordion__toggle');

    if (state == 'opened') {
      item.dataset.state = 'closed';
    } else if (state == 'closed') {
      item.dataset.state = 'opened';
    }

    item.querySelector('.wp-block-faq__answer').addEventListener(
        'transitionstart',
        function faqImageChange(e) {
            if (e.propertyName == 'max-height') {
                return;
            }
            getSiblings(item).forEach((el) => {
                if (el == item) {
                  return;
                }
                el.dataset.state = 'closed';
            });

            const images = accordion.nextElementSibling;
            if(images){
              const image = images.querySelector(
                `[data-index="${item.dataset.index}"]`
              );

              getSiblings(image)?.forEach((el) => {
                  el.classList.remove('show');
                  el.classList.add('hide');
              });

              image.classList.remove('hide');
              image.classList.add('show');
            }

            item.querySelector('.wp-block-faq__answer').removeEventListener(
                'transitionstart',
                faqImageChange
            );

        }
    );
    return;
}

function renderPopouts() {
    const images = document.querySelectorAll('.popout img');
    let loadedImagesCount = 0;

    images.forEach((img) => {
        if (img.complete) {
            handleLoadedImage();
        } else {
            img.addEventListener('load', handleLoadedImage);
        }
    });

    function handleLoadedImage() {
        loadedImagesCount++;

        if (loadedImagesCount === images.length) {
            popouts.forEach((el) => {
                const mask = el.querySelector('.popout__mask');
                if (!mask) {
                    return;
                }

                const imgContainer = el;
				        evaluateSrcset()
                setPopoutBackgroundImage(el);
                calculateDimensions();

                window.addEventListener('resize', () => {
                    let cutoffValue;
                    calculateDimensions();
                });

                // Create a ResizeObserver to monitor changes on the popout element
                const resizeObserver = new ResizeObserver(calculateDimensions);
                resizeObserver.observe(el);

                function calculateDimensions() {
                    calculateNaturalDimensions(el).then((dimensions) => {
                        mask.style.width = dimensions.width + 'px';
                        mask.style.top =
                            dimensions.height - mask.clientHeight + 'px';
                        calculateClipPath(dimensions);
                    });
                }

                function calculateClipPath(dimensions) {
                    let cutoffValue = {
                        sides:
                            (mask.clientWidth - imgContainer.clientWidth) / 2,
                        bottom:
                            mask.clientHeight -
                            (imgContainer.clientHeight +
                                (mask.clientHeight - dimensions.height)) +
                            imgContainer.clientHeight -
                            80,
                    };

                    //   mask.style.clipPath = `inset(0 0 ${cutoffValue.bottom}px )`;
                    mask.style.clipPath = `inset(0 ${cutoffValue.sides}px ${cutoffValue.bottom}px )`;
                }
            });
        }
    }
}

function evaluateSrcset() {

	popouts.forEach(popoutDiv => {
		const srcset = popoutDiv.dataset.srcset;
		const sizes = popoutDiv.dataset.sizes;

		// Get the viewport width
		const viewportWidth =
			window.innerWidth || document.documentElement.clientWidth;

		// Parse the srcset into an array of sources
		const sources = srcset.split(',').map((source) => {
			const [url, descriptor] = source.trim().split(' ');
			const width = parseInt(descriptor, 10);
			return { url, width };
		});

		// Find the most fitting source based on sizes and viewport width
		let fittingSource = sources[0];
		for (const source of sources) {
			if (
				source.width >= fittingSource.width &&
				source.width <= viewportWidth
			) {
				fittingSource = source;
			}
		}

		// Update the style attribute of the div with the selected source URL
		popoutDiv.style.setProperty('--src-image', `url('${fittingSource.url}')`);
	})
}
evaluateSrcset();
window.addEventListener('resize', evaluateSrcset);

function setPopoutBackgroundImage(el) {
    //console.log(el);

    const img = el.querySelector('img');
    const src = img.src;
    const srcset = getCurrentSrcset(img);

    const currentDimension = extractDifference(src, srcset);
    //console.log(currentDimension);
    if (currentDimension) {
        const suffix = getFileSuffix(el.dataset.image);
    }
    // const newSrc = popout.dataset.image.replace(`.${suffix}`, `-${currentDimension}.${suffix}`)
    // console.log(newSrc);

    // popout.style.setProperty('--src-image', `url('${newSrc}')`);
}

function extractDifference(url1, url2) {
    const fileSuffix = getFileSuffix(url1);
    const urlWithoutSuffix1 = url1.replace(fileSuffix, '');
    const urlWithoutSuffix2 = url2.replace(fileSuffix, '');
    const urlParts1 = urlWithoutSuffix1.split('-');
    const urlParts2 = urlWithoutSuffix2.split('-');

    let commonIndex = 0;
    while (commonIndex < Math.min(urlParts1.length, urlParts2.length)) {
        if (urlParts1[commonIndex] === urlParts2[commonIndex]) {
            commonIndex++;
        } else {
            break;
        }
    }

    if (commonIndex < urlParts2.length) {
        const differingPart = urlParts2.slice(commonIndex).join('-');
        return differingPart;
    }

    return null;
}

function getCurrentSrcset(imgElement) {
    const viewportWidth = window.innerWidth;

    // Get the srcset attribute value from the img element
    // console.log(imgElement);
    const srcset = imgElement.getAttribute('srcset');
    // console.log(srcset);
    // Split the srcset into individual sources
    const sources = srcset.split(',');

    // Iterate through the sources and find the matching source
    for (const source of sources) {
        const [sourceUrl, sourceWidth] = source.trim().split(' ');
        const width = parseInt(sourceWidth, 10);

        if (viewportWidth <= width) {
            return sourceUrl;
        }
    }

    // If no matching source is found, return the default image source
    return imgElement.src;
}

function getFileSuffix(url) {
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex !== -1) {
        return url.substring(lastDotIndex);
    }
    return '';
}

function calculateNaturalDimensions(container) {
    // Get the computed style of the container element
    const containerStyle = window.getComputedStyle(container);
    const containerWidth = parseFloat(containerStyle.width);
    const containerHeight = parseFloat(containerStyle.height);

    // Get the background image URL from the container's style
    const backgroundImage = containerStyle.backgroundImage;
    const imageUrl = backgroundImage.slice(4, -1).replace(/['"]/g, '');

    // Create a new image element
    const image = new Image();

    // Set the source of the image element to the background image URL
    image.src = imageUrl;

    // Return a promise that resolves with the calculated dimensions
    return new Promise((resolve) => {
        // When the image has loaded, calculate the dimensions
        image.onload = function () {
            // Get the natural width and height of the image
            const naturalWidth = image.naturalWidth;
            const naturalHeight = image.naturalHeight;

            // Calculate the aspect ratio of the image
            const aspectRatio = naturalWidth / naturalHeight;

            // Calculate the scaled dimensions of the image
            let scaledWidth, scaledHeight;
            if (containerWidth / containerHeight > aspectRatio) {
                scaledWidth = containerWidth;
                scaledHeight = containerWidth / aspectRatio;
            } else {
                scaledWidth = containerHeight * aspectRatio;
                scaledHeight = containerHeight;
            }

            // Return the calculated dimensions
            resolve({
                width: scaledWidth,
                height: scaledHeight,
            });
        };
    });
}

const getSiblings = (elm, withTextNodes) => {
    if (!elm || !elm.parentNode) return;

    let siblings = [
            ...elm.parentNode[withTextNodes ? 'childNodes' : 'children'],
        ],
        idx = siblings.indexOf(elm);

    siblings.before = siblings.slice(0, idx);
    siblings.after = siblings.slice(idx + 1);

    return siblings;
};



const contactForm = document.getElementById("kontaktformular_form");

const validReCaptcha = false;

if(contactForm){
  contactForm.addEventListener("submit", function (event) {

    event.preventDefault();
  
    fnameInputValidation = false;
    lnameInputValidation = false;
    phoneInputValidation = false;
    mailInputValidation = false;
    contactInputValidation = false;
    checkInputValidation = false;
  
    var fnameInput = document.getElementById("idWC_firstname");
    var lnameInput = document.getElementById("idWC_lastName");
    var phoneInput = document.getElementById("idWC_phone");
    var mailInput = document.getElementById("idWC_email");
    var checkInput = document.getElementById("idWC_datenschutz");
    var honeypotValue = document.getElementById("idWC_message").value;
  
    // Check Names
    if (fnameInput.value.trim() === "") {
      fnameInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "false");
    }
    else{
      fnameInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
      fnameInputValidation = true;
    }
  
    if (lnameInput.value.trim() === "") {
      lnameInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "false");
    }
    else{
      lnameInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
      lnameInputValidation = true;
    }
  
    // Check Contacts
    var emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var phonePattern =  /^[\d()+\s-]+$/;
  
    if (phoneInput.value.trim() === "" && mailInput.value.trim() === "") {
      document.getElementById("contactError").setAttribute("aria-hidden", "false");
      mailInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
      phoneInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
    }
    else{
      document.getElementById("contactError").setAttribute("aria-hidden", "true");
      
      if (!emailPattern.test(mailInput.value) && mailInput.value.trim() !== "") {
        mailInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "false");
      }
      else{
        mailInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
        mailInputValidation = true;
      }
      
      if (!phonePattern.test(phoneInput.value) && phoneInput.value.trim() !== "") {
        phoneInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "false");
      }
      else{
        phoneInput.parentElement.querySelector('.wpcf7-not-valid-tip').setAttribute("aria-hidden", "true");
        phoneInputValidation = true;
      }
  
      if (phoneInputValidation == true || mailInputValidation == true) {
        contactInputValidation = true;
      }
  
  
    }
  
    // Check Dataprivacy
    if (checkInput.checked == false) {
      document.getElementById("idWC_datenschutz_error").setAttribute("aria-hidden", "false");
    }
    else{
      document.getElementById("idWC_datenschutz_error").setAttribute("aria-hidden", "true");
      checkInputValidation = true;
    }
  
  
    // Submit if all is correct
    if(fnameInputValidation == true && lnameInputValidation == true && contactInputValidation == true && checkInputValidation == true && IsRecapchaValid() && honeypotValue === ''){
      this.submit();
    } 
      
  });

  // Show Dataprivacy
  contactForm.querySelectorAll("input").forEach(function (inputElement) {
    inputElement.addEventListener("input", function (event) {
      contactForm.classList.add("filled-out");    
    });
  });
}



/* 
function checkFormValidity(form) {
    let isFormValid = false;
    let emailOrPhoneFilled = false;

    const inputs = form.querySelectorAll(
        'input[aria-required="true"], input#your-email, input#phone, input#idWC_firstname, input#idWC_lastName, input#idWC_phone, input#idWC_email'
    );

    inputs.forEach((input) => {
      if (input.id == 'your-email' || input.id == 'phone' || input.id == 'idWC_email' || input.id == 'idWC_phone') {
          //console.log(input);

      } else {
          isFormValid = true;
      }
    });

    //   console.log(isFormValid);
    //   console.log(emailOrPhoneFilled);

    if (isFormValid && emailOrPhoneFilled) {
        form.classList.add('filled-out');
    } else {
        form.classList.remove('filled-out');
    }

    if (
        isFormValid &&
        emailOrPhoneFilled &&
        form.querySelector('input[type="checkbox"]').checked
    ) {
        form.classList.add('valid');
        form.classList.remove('invalid');
        return;
    } else {
        form.classList.add('invalid');
        form.classList.remove('valid');
        return;
    }
}

forms.forEach((form) => {
    const inputs = form.querySelectorAll(
        'input[aria-required="true"], input#your-email, input#phone, input[type="checkbox"], input#idWC_firstname, input#idWC_lastName, input#idWC_phone, input#idWC_email'
    );
    inputs.forEach((input) => {
        input.addEventListener('input', () => {
            checkFormValidity(form);
            console.log("taste");
        });
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (form.checkValidity()) {
            checkFormValidity(form);
            console.log("submit")
            // Form is valid, you can submit it or perform other actions here
        } else {
            form.reportValidity();
            console.log("report")
        }
    });

    let allCheckBoxes = form.querySelectorAll('input[type="checkbox"]');

    allCheckBoxes.forEach((checkBox) => {
        let label = checkBox.parentElement.querySelector(
            '.wpcf7-list-item-label'
        );
        let labelText = label.innerText;
        // console.log('labelText: ' + labelText);

        let firstIndex = labelText.indexOf('Datenschutz');
        // console.log('firstIndex: ' + firstIndex);

        let firstPart = labelText.slice(0, firstIndex);
        // console.log('firstPart: ' + firstPart);

        let midPart = labelText.slice(firstIndex, firstIndex + 11);
        // console.log('midPart: ' + midPart);

        let lastPart = labelText.slice(firstIndex + 11);

        const htmlString =
            firstPart +
            '<a href="/datenschutzerklaerung" target="_blank">' +
            midPart +
            '</a>' +
            lastPart;
        label.innerHTML = htmlString;
    });
}); */

document.querySelectorAll('a[href^="#"]').forEach((trigger) => {
  trigger.onclick = function (e) {
      e.preventDefault();
      let hash = this.getAttribute('href');
      let target = document.querySelector(hash);
      let headerOffset = 100;
      let elementPosition = target.offsetTop;
      let offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
      });
  };
});

// Cookie Logic
function isCookieSet(cookieName) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${cookieName}=`)) {
          return true;
      }
  }
  return false;
}

if (!isCookieSet('cookie_accepted')) {
  document.getElementById('cookie-notice').style.display = 'block';
}

document.getElementById('cookie-confirmed').addEventListener('click', () => {
    document.cookie = 'cookie_accepted=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    document.getElementById('cookie-notice').classList.add('fadeOut');
    console.log("Cookie Confirmed");
});

document.getElementById('cookie-denied').addEventListener('click', () => {
    document.cookie = 'cookie_accepted=false; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    document.getElementById('cookie-notice').classList.add('fadeOut');
    console.log("Cookie Denied");
});

document.getElementById('cookie-settings').addEventListener('click', () => {
    document.getElementById('cookie-notice').style.display = 'block';
    document.getElementById('cookie-notice').classList.remove('fadeOut');
    document.cookie = 'cookie_accepted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
});




